<template>
  <div id="app">

    <nav-menu></nav-menu>

    <transition name="fade" mode="out-in">
      <router-view />
    </transition>

    <footer class="footer">
      <div class="copyright">
        <p>广州甘苗信息科技有限公司 ©版权所有</p>
        <p><a href="https://beian.miit.gov.cn" target="_banlk">备案号：粤ICP备20047422号</a></p>
      </div>
    </footer>
  </div>
</template>
<script>
import navMenu from './components/navMenu.vue'
export default {
  components: { navMenu },
}
</script>
<style lang="less">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

#app {
  max-width: 1920px;
  min-height: 100vh;
  margin: 0 auto;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .en-title {
    font-size: 34px;
    font-weight: bold;
    color: #e6e6e6;
    letter-spacing: 5px;
    text-align: center;
    text-transform: uppercase;
  }

  .chs-title {
    font-size: 30px;
    font-weight: bold;
    color: #000;
    letter-spacing: 5px;
    text-align: center;
    margin-top: -30px;
  }

  img {
    -webkit-user-drag: none;
  }

  .footer {
    position: relative;
    width: 100%;
    height: 150px;
    color: #fff;
    background-color: #0b294c;

    .copyright {
      position: absolute;
      left: 50%;
      bottom: 30px;
      transform: translateX(-50%);
      text-align: center;

      a {
        color: #fff;
        text-decoration: none;
      }

      a:hover {
        color: #666;
      }
    }
  }
}

/*滚动条里面小方块*/
::-webkit-scrollbar-thumb {
  background-color: #ebeaef;
  border-radius: 10px;
}

/*滚动条整体样式*/
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

/*滚动条里面轨道*/
::-webkit-scrollbar-track {
  background: #ffffff;
  border-radius: 10px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
